import { PopulatedAssessment } from '../../types/app/populated'
import { FieldMap } from '../../types/forms/fields'
import { FieldMapValue, RedFlagRecord } from '../../types/utils/common'
import { getFieldIsRedFlagged, isFieldMap, isInfoStage, isListField } from '../../utils/fields'
import { getNestedUserFields } from '../userFields'

export const getAssessmentRedFlags = (assessment: Partial<PopulatedAssessment>) => {
  let redFlagged: RedFlagRecord = {}
  // if no unsent assessments, no red flags
  if (assessment.sentOn) return undefined
  // if (assessment.insuranceProvider?.redFlagged) {
  //   redFlagged.insuranceProvider = {
  //     header: assessment.insuranceProvider.name,
  //     reason: assessment.insuranceProvider.redFlaggedReason ?? 'Insurance provider red-flagged',
  //   }
  // }

  if (assessment.midwife?.redFlagged) {
    redFlagged.midwife = {
      header: assessment.midwife.name || 'Error getting midwife name',
      reason: assessment.midwife.redFlaggedReason || 'Midwife red-flagged',
    }
  }

  redFlagged = {
    ...redFlagged,
    ...getRedFlaggedFields(
      getNestedUserFields(true, assessment as PopulatedAssessment),
      assessment.mergedData,
    ),
  }

  return Object.keys(redFlagged).length ? redFlagged : undefined
}

export const getRedFlaggedFields = (
  fieldMap: FieldMap,
  values?: FieldMapValue,
): RedFlagRecord | undefined => {
  if (!values) return undefined
  const { children } = fieldMap
  let redFlagged: RedFlagRecord = {}
  const childKeys = Object.keys(children)
  for (const key of childKeys) {
    const child = children[key]
    if (child && !isInfoStage(child) && !isListField(child)) {
      if (isFieldMap(child)) {
        const childRedFlagged = getRedFlaggedFields(child, values[key])
        if (childRedFlagged) redFlagged = { ...redFlagged, ...childRedFlagged }
      } else {
        const childRedFlaggedReason = getFieldIsRedFlagged(child, values[key])
        if (childRedFlaggedReason) {
          redFlagged[key] = {
            reason: childRedFlaggedReason,
            header: child.placeholder,
          }
        }
      }
    }
  }
  return Object.keys(redFlagged).length !== 0 ? redFlagged : undefined
}
